import { render, staticRenderFns } from "./workcenter-hierarchy-icon.svg?vue&type=template&id=87ae5d76&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports